import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import {
  useDetector,
  useEquipment,
  useEquipmentMide,
  useUser,
} from "@services/servicesGenericsTables";
import React, { useMemo } from "react";
import { useFormContext } from "react-hook-form";

const CountingSR = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const { equipmentList } = useEquipment();
  const { currentCounting } = useAnalysis();
  const { loading } = useEquipmentMide();
  const { detectorsList } = useDetector();
  const filteredProcedures = useFilteredProcedures("CON");
  const watchEquipment = form.watch("counting_equipment");

  const filterDetectors = useMemo(() => {
    const idsEquipment = watchEquipment?.map((e) => e.id);
    return detectorsList.filter(
      (detector) => idsEquipment?.includes(detector.equipment.id) || false
    );
  }, [watchEquipment, detectorsList]);

  return (
    <>
      {currentCounting.index !== undefined ? (
        <React.Fragment key={currentCounting.id}>
          <ResponsiveFormContainer columns={5}>
            <MAutocomplete
              name="counting_analyst"
              options={userList}
              label="Seleccione un analista"
              getOptionLabel={(option) => option.username || ""}
              validation={{ required: "El analista es requerido" }}
              disabled={!currentCounting.canEdit}
            />

            <MAutocomplete
              name="counting_procedure"
              options={filteredProcedures}
              label="Procedimiento MLPMA"
              getOptionLabel={(option) => `${option.numop}` || ""}
              disabled={!currentCounting.canEdit}
            />
            <MAutocomplete
              key={`counting_equipment-${form.getValues("counting_equipment")}`}
              name="counting_equipment"
              options={equipmentList}
              label="Seleccione un Equipo"
              getOptionLabel={(option) =>
                `${option.codigo} - ${option.descripcion}` || ""
              }
              validation={{ required: "El equipo es requerido" }}
              loading={loading}
              disabled={!currentCounting.canEdit}
              multiple={true}
            />
            <MAutocomplete
              key={JSON.stringify(form.getValues("counting_detector"))}
              name="counting_detector"
              options={filterDetectors}
              label="Detector"
              getOptionLabel={(option) => `${option.name}` || ""}
              multiple
              disabled={!currentCounting.canEdit}
            />
            <MDatePicker
              key="counting_date"
              name="counting_date"
              pickerType="date"
              label="Fecha de contaje"
              validation={{
                required: "La fecha de contaje es requerida",
              }}
              disabled={!currentCounting.canEdit}
            />
          </ResponsiveFormContainer>

          <ResponsiveFormContainer columns={5} mt={2}>
            <MDatePicker
              key="first_counting_date"
              name="first_counting_date"
              pickerType="datetime"
              label="Fecha y hora de inicio 1er contaje"
              validation={{
                required: "La fecha de contaje es requerida",
              }}
              disabled={!currentCounting.canEdit}
            />
            <MTextField
              name="first_counting_time"
              placeholder="Tiempo total 1er contaje (min)"
              label="Tiempo total 1er contaje (min)"
              type="number"
              validation={{ required: "El tiempo total es requerido" }}
              fullWidth
              step="0.01"
              disabled={!currentCounting.canEdit}
            />
            <MTextField
              name="first_counting_cpm"
              placeholder="cpm 1er contaje"
              label="cpm 1er contaje"
              type="number"
              validation={{ required: "El cpm es requerido" }}
              fullWidth
              step="0.01"
              disabled={!currentCounting.canEdit}
            />
            <MDatePicker
              key="second_counting_date"
              name="second_counting_date"
              pickerType="datetime"
              label="Fecha y hora de inicio 2er contaje"
              disabled={!currentCounting.canEdit}
            />
            <MTextField
              name="second_counting_time"
              placeholder="Tiempo total 2er contaje (min)"
              label="Tiempo total 2er contaje (min)"
              type="number"
              fullWidth
              step="0.01"
              disabled={!currentCounting.canEdit}
            />
            <MTextField
              name="second_counting_cpm"
              placeholder="cpm 2do contaje"
              label="cpm 2do contaje"
              type="number"
              fullWidth
              step="0.01"
              disabled={!currentCounting.canEdit}
            />

            <MTextField
              name="counting_valid"
              placeholder="Contaje Válido"
              label="Contaje Válido"
              type="text"
              fullWidth
              disabled
            />
          </ResponsiveFormContainer>
        </React.Fragment>
      ) : null}
    </>
  );
};

export default CountingSR;
